import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

export function permissionCalendar(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const hasPermission = PermissionClass.can(LIST_PERMISSION.CALENDAR);

  if (!hasPermission) {
    next({
      name: 'calendario'
    });
  }
  next();
}
